var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAmex(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70.36 39.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:#fff;}.cls-1{stroke:#ccc;stroke-miterlimit:10;}.cls-2{fill:#2f6eb7;}.cls-2,.cls-3{fill-rule:evenodd;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.5,
    y: 0.5,
    width: 69.36,
    height: 38.19,
    rx: 2.83
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "21.83 6.23 48.53 6.23 48.53 32.92 21.83 32.92 21.83 6.23 21.83 6.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "31.5 28.7 31.5 19.14 48.53 19.15 48.53 21.79 46.56 23.89 48.53 26.02 48.53 28.71 45.38 28.71 43.72 26.87 42.06 28.72 31.5 28.7 31.5 28.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "32.64 27.65 32.64 20.19 38.97 20.19 38.97 21.91 34.69 21.91 34.69 23.07 38.87 23.07 38.87 24.76 34.69 24.76 34.69 25.91 38.97 25.91 38.97 27.65 32.64 27.65 32.64 27.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "38.94 27.65 42.44 23.91 38.94 20.19 41.65 20.19 43.79 22.55 45.93 20.19 48.53 20.19 48.53 20.25 45.1 23.91 48.53 27.54 48.53 27.65 45.91 27.65 43.73 25.26 41.57 27.65 38.94 27.65 38.94 27.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "32.3 10.64 36.4 10.64 37.84 13.92 37.84 10.64 42.91 10.64 43.78 13.1 44.66 10.64 48.53 10.64 48.53 20.21 28.08 20.21 32.3 10.64 32.3 10.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33.07,11.68l-3.31,7.46H32l.63-1.49H36l.63,1.49H39l-3.3-7.46ZM33.36,16l1-2.37,1,2.37Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "38.97 19.14 38.97 11.68 42.16 11.69 43.8 16.28 45.45 11.68 48.53 11.68 48.53 19.14 46.55 19.16 46.55 14.04 44.68 19.14 42.88 19.14 40.97 14.02 40.97 19.14 38.97 19.14 38.97 19.14"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmex);
export default __webpack_public_path__ + "static/media/amex.a71be761e8c1e4e7fd0891f2093f17b7.svg";
export { ForwardRef as ReactComponent };